import { Component, OnInit } from '@angular/core';
import { ThemeService } from '../../services/theme.service';

@Component({
    selector: 'app-theme-toggle',
    template: `
    <button 
      class="theme-toggle-btn" 
      (click)="toggleTheme()"
      [title]="isDark ? 'Chuyển sang chế độ sáng' : 'Chuyển sang chế độ tối'">
      <span class="theme-icon">{{ isDark ? '☀️' : '🌙' }}</span>
    </button>
  `,
    styles: [`
    .theme-toggle-btn {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 6px;
      font-size: 20px;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
    }
    
    .theme-toggle-btn:hover {
      background-color: rgba(0, 0, 0, 0.05);
      transform: rotate(20deg);
    }
    
    .theme-toggle-btn:active {
      transform: scale(0.95) rotate(20deg);
    }
    
    .theme-icon {
      font-size: 20px;
      transition: transform 0.3s ease;
      display: inline-block;
    }
  `]
})
export class ThemeToggleComponent implements OnInit {
    isDark = false;

    constructor(private themeService: ThemeService) { }

    ngOnInit(): void {
        // Subscribe to theme changes
        this.themeService.currentTheme$.subscribe(theme => {
            this.isDark = theme === 'dark';
        });
    }

    toggleTheme(): void {
        this.themeService.toggleTheme();
    }
}
